export default {
    name: 'ContextPage',
    properties: {
        uri: { required: true },
        custom: {},
    },
};
